<template>
  <VeeForm class="signup-form" @submit="onSignup">
    <h2>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.@WELCOME_PART1")) }}</h2>
    <p>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.@WELCOME_PART2")) }}</p>

    <fieldset>
      <!-- email -->
      <Field
        v-slot="{ errors, field, value }"
        v-model.trim="email"
        :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@EMAIL'))"
        :rules="'required|email'"
      >
        <QInput
          v-bind="field"
          :model-value="value"
          class="q-input-borderless"
          :label="$t('ETAB.FORMS.LABELS.@EMAIL')"
          tabindex="1"
          filled
          dark
          clearable
          color="white"
          :name="ISignup.email"
          type="email"
          :error="errors.length > 0"
          :error-message="errors[0]"
        />
      </Field>
    </fieldset>
    <QField borderless class="q-mb-md optin" dense>
      <IosCheckbox v-model="optin" tabindex="5" :label="$t('ETAB.PAGES.SIGNUP.@NEWSLETTER')" aria-checked="true" />
    </QField>
    <fieldset>
      <QBtn :label="$t('ETAB.BUTTONS.@INSCRIPTION')" type="submit" color="secondary" class="full-width btn-navigation" no-caps />
      <div class="q-my-md cgu">
        {{ $t("ETAB.FORMS.LABELS.@CGU_ACCEPT") }}
        <a :href="CGU_URL" target="_blank">{{ $t("ETAB.FORMS.LABELS.@CGU") }}</a>
      </div>
      <QBtn :label="$t('ETAB.BUTTONS.@I_ALREADY_HAVE_AN_ACCOUNT')" color="white" class="full-width btn-navigation" no-caps flat @click="goToLogin" />
    </fieldset>
  </VeeForm>
</template>

<script>
  import { Form as VeeForm, Field } from "vee-validate";
  import { ISignup } from "@core/models";
  import { CGU_URL } from "@core/constants";
  import { MetaHelpers } from "@core/helpers";
  import { TrackingManager } from "@core/managers/tracking.manager";

  export default {
    components: {
      VeeForm,
      Field,
    },
    props: {
      prefilledEmail: { type: String, default: "" },
    },
    emits: ["onSignup", "goToLogin"],
    meta() {
      return MetaHelpers.setAutoMeta({
        title: this.$t("ETAB.PAGES.SIGNUP.META.@TITLE"),
        description: this.$t("ETAB.PAGES.SIGNUP.META.@DESCRIPTION"),
        canonical: `${window.location.origin}${window.location.pathname}${window.location.hash.split("?")[0]}`,
      });
    },
    data() {
      return {
        isPwd: false,
        email: "",
        optin: true,
      };
    },
    created() {
      this.ISignup = ISignup;
      // pre-fill login from signup page
      this.email = this.prefilledEmail;
      this.CGU_URL = CGU_URL;
    },
    methods: {
      async onSignup() {
        this.$emit("onSignup", this.email, this.optin);
      },
      goToLogin() {
        TrackingManager.addEvent({
          event: "already_have_account",
        });
        this.$emit("goToLogin", { email: this.email });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signup-form {
    .cgu {
      font-size: 13px;
      margin-top: 0;
    }
    h2 {
      text-align: center;
      margin: 0 0 12px;
      font-size: 1.6rem;
    }
    p {
      font-size: 1.3rem;
      text-align: center;
    }
    a {
      color: #ffff;
    }

    fieldset:first-of-type {
      display: flex;
      flex-direction: column;
    }

    button:first-of-type {
      margin-bottom: 10px;
    }
  }
</style>
